import { render, staticRenderFns } from "./NfeTotalization.vue?vue&type=template&id=16cb0a3c&"
import script from "./NfeTotalization.vue?vue&type=script&lang=js&"
export * from "./NfeTotalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports